module.exports = __webpack_public_path__ + "img/about/80243-027.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-027.png
// module id = 30
// module chunks = 0